<template>
  <div class="work-container">
    <a-row type="flex" class="work-grid" justify="start">
      <template v-for="work in worksData">
        <a-col :span="6" class="work-grid-column" :key="work.numero">
          <WorkItem
          :numero="work.numero"
          :title="work.titreTravail"
          :creationDate="work.dateCreation"
          @clicked="handleClickWork"
          @onDelete="handleDeleteWork" />
        </a-col>
      </template>
      <template v-if="Array.isArray(studentsData) && studentsData.length || user.permissionLevel === 0">
        <a-col :span="6" class="work-grid-column">
          <AddWorkItem />
        </a-col>
      </template>
    </a-row>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import WorkItem from '@/components/work/WorkItem.vue'
import AddWorkItem from '@/components/work/AddWorkItem.vue'
import WorkService from '../../services/work_service'

export default {
  name: 'WorkGrid',
  components: {
    WorkItem,
    AddWorkItem
  },
  methods: {
    moment,
    ...mapActions({
      'setWorksData': 'work/setWorksData',
      'setSelectedWork': 'work/setSelectedWork',
      'sortWorksNonChronological': 'work/sortWorksNonChronological',
      'removeWork': 'work/removeWork',
      'setLoading': 'work/setLoading'
    }),
    handleClickWork (numero) {
      this.$router.push('/details/' + numero)
    },
    async handleDeleteWork (numero) {
      console.log('deleting ' + numero)
      const response = await WorkService.removeWork(numero)
      if (response) {
        const newData = [...this.worksData]
        const target = newData.filter(item => numero === item.numero)[0]
        if (target) {
          // On récupère l'index array du travail à supprimer
          let index = newData.indexOf(target)
          this.removeWork(index)
        }
        this.$message.success('Travail supprimé')
      }
    }
  },
  computed: {
    ...mapState({
      worksData: state => state.work.worksData,
      user: state => state.auth.user,
      loading: state => state.work.loading,
      studentsData: state => state.ldap.studentsData
    })
  }
}
</script>

<style scoped lang="scss">
// Affiche les travaux sur deux colonnes en dessous de 768px
@media screen and (max-width: 424px){
    .work-grid-column{
      flex-basis: 100%;
    }
}
@media screen and (min-width: 425px) and (max-width: 767px){
    .work-grid-column{
      flex-basis: 50%;
    }
}
@media screen and (min-width: 768px) and (max-width: 1100px){
    .work-grid-column{
        flex-basis: 33%;
    }
}
</style>
